import { css, makeStyles } from '@conexasaude/conexa-hero'

const useStyles = makeStyles({
  divisorLine: theme => css`
    background-color: ${theme.colors.neutral[100]};
    height: 1px;
    margin: ${theme.spacing.xs} 0;
  `,
})

export default useStyles
